<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-9">
        <div class="container">
          <div class="row" v-for="org in organizations">
            <div class="col-sm-2 utilization-name"><h6 class="sub-header">{{ org.name }}</h6></div>
            <div class="col-sm-10"><CompGraph :id="org.name.replace(/[^a-zA-Z0-9]/g, '')" :data="org.data" :palette="palette" unit="pre-certs" /></div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <ul class="legend list-unstyled">
          <li v-for="log in logs">
            <span><svg class="legend-swatch"><rect width="100%" height="100%" :fill="palette(log.name)" /></svg>
            {{ log.name }}</span><br />
            <span class="legend-label">{{ log.count.toLocaleString() }} pre-certs</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import * as d3 from 'd3'
  import * as roll from '@/components/mixins/roll'

  import CompGraph from '@/components/widgets/CompGraph'

  // byName is a comparison function for Array.sort that puts the array in
  // alphabetical order, other than the name 'Other' which is always last.
  function byName(a, b) {
    if (a.name == 'Other') {
      return 1
    } else if (b.name == 'Other') {
      return -1
    } else if (a.name < b.name) {
      return -1
    } else if (a.name > b.name) {
      return 1
    }
    return 0
  }
  // byOrganization is a comparison function for Array.sort that puts names into
  // pre-sorted buckets depending on the organization name that's present.
  function byOrganization(a, b) {
    const orgs = ['Google', 'DigiCert', 'Let\'s Encrypt', 'Sectigo', 'Cloudflare']

    let aIdx = orgs.length, bIdx = orgs.length
    for (let i = 0; i < orgs.length; i++) {
      if (a.name.includes(orgs[i])) {
        aIdx = i
      }
      if (b.name.includes(orgs[i])) {
        bIdx = i
      }
    }

    if (aIdx < bIdx) {
      return -1
    } else if (aIdx > bIdx) {
      return 1
    }
    return byName(a, b)
  }

  export default {
    name: 'UtilGraph',
    props: {
      data: {type: Array, required: true},
    },
    data: function() {
      let googleColors = d3.scaleOrdinal(['#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#4a1486'])
      let caColors = d3.scaleOrdinal(['#fdae6b','#fd8d3c','#f16913','#d94801','#a63603'])
      let otherColors = d3.scaleOrdinal(['#66c2a4','#41ae76','#238b45','#006d2c','#00441b'])

      return {
        palette: function(name) {
          if (name.includes('Google')) {
            return googleColors(name)
          } else if (name.includes('DigiCert') || name.includes('Let\'s Encrypt') || name.includes('Sectigo')) {
            return caColors(name)
          }
          return otherColors(name)
        },
      }
    },
    computed: {
      organizations: function() {
        return this.data.map(function(d) {
          return {name: d.Name, data: roll.itemize(d.Data).sort(byOrganization)}
        }).sort(byName)
      },
      logs: function() {
        let acc = this.organizations.reduce(function(acc, org) {
          for (let i = 0; i < org.data.length; i++) {
            let name = org.data[i].name, count = org.data[i].count
            if (name in acc) {
              acc[name] += count
            } else {
              acc[name] = count
            }
          }
          return acc
        }, {})

        let out = []
        for (let name in acc) {
          out.push({name: name, count: acc[name]})
        }
        return out.sort(byOrganization)
          .filter(function(x) { return x.name != 'Other'})
      },
    },
    components: { CompGraph },
  }
</script>

<style scoped>
  h6.sub-header {
    padding: 0.1rem;
    margin: 0;
    border-bottom: none;
    text-align: center;
  }

  div.utilization-name {
    padding-top: 0.5rem;
    padding-bottom: 1rem;
  }
  div.utilization-name h6 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ul.legend {
    margin-top: 1em;
  }
  svg.legend-swatch {
    width: 1.25em;
    height: 1.25em;

    position: relative;
    top: 0.25em;
  }
  span.legend-label {
    padding-left: 1.7em;

    font-weight: lighter;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/UtilGraph.vue